import React from 'react';
import { VStack } from '@chakra-ui/react';

import Fill from './components/Fill';
import ImageHotspots from './components/ImageHotspots';
import ImageHotspotsDragNDrop from './components/ImageHotspotsDnd';
import ImageClickHotspots from './components/ImageClickHotspots';
import FillDnd from './components/FillDnd';
import MarkTheWords from './components/MarkTheWords';
import CardFlip from './components/CardFlip';
import Associations from './components/Associations';

const InteractiveTestPage = (props: any) => {
  return (
    <VStack p={8} spacing={0} gap={16} w="full">
      {/* <Fill
        text="This is a xy_____yx component that doesn't have xy_____yx."
        slots={[
          { index: 0, key: 'component', answer: 'fill' },
          { index: 1, key: 'feature', answer: 'drag and drop' },
        ]}
      />
      <Fill
        text={
          "Bananas are totally xy_____yx!\nAnd this is a new line that's totally xy_____yx."
        }
        slots={[
          { index: 0, key: 'a1', answer: 'bananas' },
          { index: 1, key: 'a2', answer: 'mango' },
        ]}
      /> */}
      {/* <FillDnd
        text={
          "Bananas are totally xy_____yx!\nAnd this is a new line that's totally xy_____yx. Hmmmm xy_____yx?"
        }
        slots={[
          { index: 0, key: 'a1', answer: 'bananas' },
          { index: 1, key: 'a2', answer: 'mango' },
          { index: 2, key: 'a3', answer: 'apricot' },
        ]}
      /> */}
      {/* <ImageHotspots
        src="/static/ui/image-hotspots.jpg"
        spots={[
          { x: '12.5%', y: '15%', info: 'Pepperoni', emotion: 'positive' },
          { x: '35%', y: '70%', info: 'Kiwinoni', emotion: 'positive' },
          { x: '90%', y: '20%', info: 'Cucumber', emotion: 'fuj' },
        ]}
      />
      <ImageHotspots
        w="50%"
        h="auto"
        src="/static/ui/image-hotspots.jpg"
        spots={[
          { x: '12.5%', y: '15%', info: 'Pepperoni', emotion: 'positive' },
          { x: '35%', y: '70%', info: 'Kiwinoni', emotion: 'positive' },
          { x: '90%', y: '20%', info: 'Cucumber', emotion: 'fuj' },
        ]}
      />
      <ImageClickHotspots
        src="/static/ui/image-hotspots.jpg"
        spots={[
          {
            answer: 'Pepper',
            key: 'pepper',
            type: 'Rectangle',
            points: [
              { x: '4.33%', y: '12.45%' },
              { x: '22.3%', y: '43.14%' },
            ],
          },
          {
            answer: 'Onion',
            key: 'onion',
            type: 'Rectangle',
            points: [
              { x: '25.33%', y: '4.45%' },
              { x: '48.48%', y: '46.54%' },
            ],
          },
        ]}
      /> */}
      {/* <ImageHotspotsDragNDrop
        src="/static/ui/image-hotspots.jpg"
        spots={[
          {
            answer: 'Pepper',
            key: 'pepper',
            type: 'Rectangle',
            points: [
              { x: '4.33%', y: '12.45%' },
              { x: '22.3%', y: '43.14%' },
            ],
          },
          {
            answer: 'Onion',
            key: 'onion',
            type: 'Rectangle',
            points: [
              { x: '25.33%', y: '4.45%' },
              { x: '48.48%', y: '46.54%' },
            ],
          },
        ]}
      /> */}
      {/* <MarkTheWords
        text="Example text that is only for example purposes fitbit test test test"
        words={[
          { index: 0 },
          { match: 'fitbit' },
          { index: 3 },
          { match: 'test' },
        ]}
      /> */}
      {/* <CardFlip
        card={{
          content: [
            { type: 'text', src: 'This is an example text', align: 'center' },
            {
              type: 'image',
              src: 'https://picsum.photos/id/236/200/300',
              align: 'center',
            },
          ],
          alternativeContent: [
            {
              type: 'image',
              src: 'https://picsum.photos/id/237/200/300',
              align: 'right',
            },
            {
              type: 'text',
              src: 'This is alternative example text This is alternative example text This is alternative example text This is alternative example text',
              align: 'justify',
              textAlign: 'right',
            },
            {
              type: 'audio',
              src: '/static/ui/Dog Woof Sound.mp3',
              align: 'center',
            },
          ],
        }}
      /> */}
      {/* <Associations
        w="800px"
        associations={[
          {
            left: { type: 'text', src: 'Test 1' },
            right: { type: 'text', src: 'Answer 1' },
          },
          {
            left: { type: 'text', src: 'Test 2' },
            right: {
              type: 'image',
              src: 'https://picsum.photos/id/237/200/200',
            },
          },
          {
            left: {
              type: 'image',
              src: 'https://picsum.photos/id/237/200/200',
            },
            right: { type: 'text', src: 'Answer 3' },
          },
          {
            left: { type: 'text', src: 'What sound does a dog make?' },
            right: { type: 'audio', src: '/static/ui/Dog Woof Sound.mp3' },
          },
          {
            left: { type: 'audio', src: '/static/ui/Dog Woof Sound.mp3' },
            right: { type: 'text', src: 'Woof' },
          },
        ]}
      /> */}
    </VStack>
  );
};

export default InteractiveTestPage;
